export function generateErrorMessage(response: any , isNewItem:boolean = true) {

  const errorResponse = response?.response?.data?.data;
  if (errorResponse && Array.isArray(errorResponse)) {
    if (errorResponse[0].code === "VENUE_GROUP_NICKNAME_ALREADY_EXISTS") {
      return "snackbar.groupNicknameExists";

    }else if (errorResponse[0].code === "VENUE_ALREADY_ATTACHED_TO_OTHER_VENUE_GROUP") {
      return "snackbar.venueAttached";
    }else if (errorResponse[0].code === "MUST_HAVE_AT_LEAST_ONE_GROUP_AREA_ENABLED"){
      return "snackbar.venueAreaEnabled";
    }
  }
  return isNewItem ? "groups.form.error.create" : "groups.form.error.update";
}